import {
  useEffect, useRef, useState
} from 'react';
import useSWR from 'swr';

import { swrOrchestrationListFetcher } from '../api_functions/orchestrationListFetch';

import useWorkspaceContext from '../../components/workspaces/WorkspaceContext/WorkspaceContext';

const useOrchestrationById = (orchestrationId) => {
  const errorTimeoutRef = useRef(null);
  const [errorMessage, setError] = useState(null);

  const { currentWorkspaceId: workspaceId } = useWorkspaceContext()

  // FIXME - Using list endpoint - get_by_id doesn't provide all data
  const {
    data, error, isLoading,
  } = useSWR([workspaceId, 'orch-by-id'], swrOrchestrationListFetcher, { refreshInterval: 3000 })

  const orchestrationInstance = data?.length ? data.find(({ id }) => id === orchestrationId) : null;

  useEffect(() => {
    if (error) {
      errorTimeoutRef.current = setTimeout(() => {
        setError(error?.message);
      }, 1500);
    } else {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }

    return () => {
      clearTimeout(errorTimeoutRef.current);
      setError(null);
    }
  }, [error]);

  return {
    orchestration: orchestrationInstance,
    error: errorMessage,
    loading: isLoading,
  };
};
export default useOrchestrationById;
